import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影资讯", to: "/category/news" },
  { label: "影片推荐", to: "/category/recommend" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/80 backdrop-blur-sm"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-film-line text-background-50 text-xl" />
            </span>
            <span className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950 tracking-tight">
              91<span className="text-accent-500">电影</span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-primary-700 bg-primary-50"
                      : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 md:gap-3">
            <form onSubmit={submitSearch} className="hidden md:flex items-center">
              <div className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 h-10 w-44 lg:w-56">
                <i className="ri-search-line text-foreground-500 text-base" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影片或资讯"
                  className="bg-transparent outline-none text-sm w-full text-foreground-800 placeholder:text-foreground-400"
                />
              </div>
            </form>

            <Link
              to="/search"
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl" />
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
              aria-label="菜单"
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="lg:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 flex flex-col gap-1">
            <form onSubmit={submitSearch} className="mb-2 md:hidden">
              <div className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-md px-3 h-11">
                <i className="ri-search-line text-foreground-500 text-base" />
                <input
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索影片或资讯"
                  className="bg-transparent outline-none text-sm w-full text-foreground-800 placeholder:text-foreground-400"
                />
              </div>
            </form>
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "text-primary-700 bg-primary-50"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}